import React from 'react'
import { default as ReactTooltip } from 'react-tooltip-lite'
import { isNumber } from '@mote/helpers'
import { isMobile } from '@mote/helpers/browser'
import { __DEV__ } from '@mote/helpers/constants'
import styled, { css } from '@xstyled/styled-components'

/**
 * @deprecated
 */
export const Tooltip = React.forwardRef((props, ref) => {
  const {
    children = <></>,
    disabled,
    ...rest
  } = React.useMemo(() => {
    const defaultProps = {
      height: 'auto',
      direction: 'down',
      disabled: isMobile(),
      arrow: false,
      arrowSize: 6,
      zIndex: 10000,
      padding: '4px 8px',
      distance: props.arrow ? 10 : 5,
      variant: 'mote'
    }

    switch (props.variant) {
      case 'google-black-legacy': {
        return {
          ...defaultProps,
          padding: '7px 9px',
          arrow: true,
          arrowSize: 6,
          ...props
        }
      }
      case 'google-black': {
        return {
          ...defaultProps,
          padding: '3px 8px',
          ...props
        }
      }

      case 'google-grey': {
        return {
          ...defaultProps,
          padding: '5px 8px 6px',
          ...props
        }
      }

      default: {
        return { ...defaultProps, ...props }
      }
    }
  }, [props])

  if (disabled) return <>{children}</>

  return (
    <StyledTooltip {...rest} ref={ref}>
      {children}
    </StyledTooltip>
  )
})

if (__DEV__) {
  Tooltip.displayName = 'Tooltip'
}

const StyledTooltip = styled(ReactTooltip)`
  min-width: 0;

  .react-tooltip-lite {
    cursor: default;
    font-style: normal;
    font-weight: 500;
    color: white;
  }

  ${({ variant, width, height }) => {
    switch (variant) {
      case 'google-black-legacy':
        return css`
          .react-tooltip-lite {
            display: block;
            border-radius: 0;
            box-shadow: none;
            font-size: 12px;
            white-space: pre-wrap;
            word-break: break-word;
            border: 1px solid #fff;
            background-color: #2a2a2a;
          }

          .react-tooltip-lite-arrow {
            border-color: #2a2a2a;
          }
        `
      case 'google-black':
        return css`
          .react-tooltip-lite {
            display: block;
            background-color: #1f1f1f;
            border: 1px solid transparent;
            border-radius: 4px;
            color: #f2f2f2;
            font-size: 12px;
            font-weight: 400;
            min-height: 16px;
            letter-spacing: 0.1px;
            line-height: 16px;
          }

          .react-tooltip-lite-arrow {
            border-color: #1f1f1f;
          }
        `
      case 'google-grey':
        return css`
          .react-tooltip-lite {
            display: block;
            border-radius: 2px;
            font-size: 10px;
            font-weight: 500;
            white-space: pre-wrap;
            word-break: break-word;
            background-color: rgba(97, 97, 97, 0.902);
          }
        `

      default:
        return css`
          .react-tooltip-lite {
            border-radius: 4px;
            font-size: 10px;
            line-height: 13px;
            background: black;
            height: ${isNumber(height) ? `${height}px` : height};
            width: ${isNumber(width) ? `${width}px` : width};
          }

          .react-tooltip-lite-arrow {
            border-color: black;
          }
        `
    }
  }};

  ${({ variant, direction }) => {
    if (variant !== 'google-black-legacy') return

    if (direction.includes('up')) {
      return css`
        .react-tooltip-lite {
          margin-top: 1px;
        }
      `
    }

    if (direction.includes('down')) {
      return css`
        .react-tooltip-lite {
          margin-top: -1px;
        }
      `
    }

    if (direction.includes('right')) {
      return css`
        .react-tooltip-lite {
          margin-left: -1px;
        }
      `
    }

    if (direction.includes('left')) {
      return css`
        .react-tooltip-lite {
          margin-right: -1px;
        }
      `
    }
  }};

  .react-tooltip-lite-arrow {
    ${({ arrow }) => !arrow && 'display: none;'};
  }
`
